import { Controller, FieldValues, useController } from 'react-hook-form';

import { CarouselButton } from '@/components/UI/CarouselButton/CarouselButton';
import { FieldError } from '@/components/UI/Fields/FieldError';
import { FieldProps } from '@/components/UI/Fields/types';
import { Label } from '@/components/UI/Label/Label';

import styles from './CarouselButtonField.module.css';

type CarouselButtonFieldProps<T extends FieldValues> = FieldProps<T> & {
  onChangeCallback?: (value: string) => void;
} & Omit<React.ComponentPropsWithoutRef<typeof CarouselButton>, keyof FieldProps<T>>;

export const CarouselButtonField = <T extends FieldValues>({
  control,
  name,
  onChangeCallback,
  items,
  label,
  required,
  rules,
  defaultValue,
  ...rest
}: CarouselButtonFieldProps<T>) => {
  const { fieldState } = useController<T>({
    name,
    control,
    rules: { required: required ? 'dit veld is verplicht' : undefined, ...rules },
    defaultValue,
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div>{label && <Label>{label}</Label>}</div>
      <div className={styles.inputContainer}>
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue}
          render={({ field }) => (
            <CarouselButton
              items={items}
              defaultValue={defaultValue}
              {...field}
              {...rest}
              onChange={(value) => {
                field.onChange(value);
                onChangeCallback?.(value);
              }}
            />
          )}
        />
        <FieldError width='auto' error={fieldState.error} />
      </div>
    </div>
  );
};
